import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <main className="flex h-screen w-full flex-col items-center justify-center bg-[#1A2238]">
      <h1 className="text-9xl font-extrabold tracking-widest text-white">۴۰۴</h1>
      <div className="absolute rotate-12 rounded bg-[#FF6A3D] px-2 text-sm">
        صفحه موردنظر یافت نشد
      </div>
      <button className="mt-5">
        <a className="group relative inline-block text-sm font-medium text-[#FF6A3D] focus:outline-none focus:ring active:text-orange-500">
          <span className="absolute inset-0 translate-x-0.5 translate-y-0.5 bg-[#FF6A3D] transition-transform group-hover:translate-x-0 group-hover:translate-y-0"></span>
          <span
            onClick={() => navigate("/")}
            className="relative block border border-current bg-[#1A2238] px-8 py-3"
          >
            <span>صفحه اصلی</span>
          </span>
        </a>
      </button>
    </main>
  );
};

export default NotFound;
